import React from 'react';
import { Flex, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
const { Text } = Typography;

const SpiralLoader = ({content="Loading..."}) => {
    return (
        <div style={{display: "flex", gap:"10px", backgroundColor: "#D3C7F7", width:"fit-content", height:"fit-content", padding:"10px", borderRadius: "20px", display: "flex", alignItems: "center", justifyContent: "center"}}>  
            <Spin indicator={<LoadingOutlined color='#000' spin />} size="medium" />
            <Text strong>{content}</Text>
        </div>
    );
};

export default SpiralLoader;
